import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { PRICING } from "@/data/content";

export const Pricing = () => {
  return (
    <section id="tarifs" data-testid="pricing-section" className="py-20 sm:py-24 md:py-32 relative overflow-hidden scroll-mt-24">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[40rem] h-[40rem] bg-accent/5 blur-3xl rounded-full pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-12 sm:mb-16">
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-accent mb-4">Gestion SaaS · humaine</p>
          <h2 className="font-heading font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl">
            Des tarifs clairs, un suivi sur mesure.
          </h2>
          <p className="mt-5 text-muted-foreground">
            Un abonnement mensuel, sans engagement caché. Opéré par des experts, pas par un robot.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-stretch">
          {PRICING.map((tier, i) => (
            <motion.div
              key={tier.name}
              data-testid={`pricing-card-${tier.name.toLowerCase()}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className={`relative flex flex-col p-7 sm:p-8 border ${
                tier.highlighted ? "border-accent bg-surface glow-accent lg:scale-[1.03]" : "border-border bg-surface"
              }`}
            >
              {tier.highlighted && (
                <span className="absolute -top-3 left-8 bg-accent text-background font-mono text-[10px] tracking-[0.2em] uppercase px-3 py-1">
                  Populaire
                </span>
              )}
              <h3 className="font-heading font-semibold text-2xl">{tier.name}</h3>
              <p className="text-sm text-muted-foreground mt-2 mb-6 sm:h-10">{tier.tagline}</p>
              <div className="flex items-end gap-1 mb-8">
                {tier.price === "Sur devis" ? (
                  <span className="font-heading font-black text-4xl">Sur devis</span>
                ) : (
                  <>
                    <span className="font-heading font-black text-5xl">{tier.price}€</span>
                    <span className="text-muted-foreground mb-2 text-sm">{tier.period}</span>
                  </>
                )}
              </div>
              <ul className="space-y-4 mb-8 flex-1">
                {tier.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm">
                    <Check size={18} className="text-accent shrink-0 mt-0.5" />
                    <span className="text-foreground/80">{f}</span>
                  </li>
                ))}
              </ul>
              <Link
                to={`/contact?sujet=${encodeURIComponent("Offre " + tier.name)}`}
                data-testid={`pricing-cta-${tier.name.toLowerCase()}`}
                className={`text-center font-semibold px-6 py-3 transition-colors ${
                  tier.highlighted
                    ? "bg-accent text-background hover:bg-accent-hover"
                    : "border border-border text-foreground hover:border-accent/40"
                }`}
              >
                {tier.price === "Sur devis" ? "Demander un devis" : "Choisir cette offre"}
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
